var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg12IconHisIconsLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#222B45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.833 3.333c.459 0 .834.375.834.834 0 .458-.375.833-.834.833H5v10h.833c.459 0 .834.375.834.833 0 .459-.375.834-.834.834H4.167c-.459 0-.834-.375-.834-.834V4.167c0-.459.375-.834.834-.834zm8.01 2.652c.375-.266.895-.174 1.16.202l2.345 3.334c.209.295.202.69-.015.979l-2.5 3.333c-.163.219-.414.333-.667.333-.174 0-.35-.054-.5-.166-.368-.276-.442-.799-.166-1.166l1.5-2H8.334c-.46 0-.833-.373-.833-.834 0-.461.373-.834.833-.834H15c.025 0 .047.013.072.015L13.64 7.146c-.265-.376-.174-.896.202-1.161z",
    transform: "translate(-1134 -238) translate(1095 70) translate(16 158.894) translate(23.5 10)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12IconHisIconsLogOut);
export default __webpack_public_path__ + "static/media/1-2-icon-his-icons-log-out.2ed5ce2b.svg";
export { ForwardRef as ReactComponent };